import config from '@/assets/config.json'
import { LogLevel } from '@azure/msal-browser';

const { apiUrl, msal } = config;

export default {
  auth: {
    tenantId: msal.tenantId,
    clientId: msal.clientId,
    authority: 'https://login.microsoftonline.com/organizations/v2.0',
    validateAuthority: true,
    redirectUri: msal.redirectUri,
    postLogoutRedirectUri: msal.postLogoutRedirectUri,
    navigateToLoginRequestUrl: true,
    allowedTenantIds: msal.allowedTenantIds
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
    accessTokenRefreshIntervalSeconds: 900
  },
  resources: {
    api: {
      resourceUri: apiUrl,
      resourceScope: [msal.resourceScope]
    }
  }
}